<template>
  <div class="e-tooltip" ref="tooltip" :class="{'e-tooltip__open': isPopupOpen}" v-click-outside="closePopup">
    <i :class="getClassesForIcon()" @click="switchPopup"></i>
    <div class="e-tooltip__text" :class="{'e-tooltip__text__show': isPopupOpen}" :style="{top: topOffset }">
      <div class="e-tooltip__text__arrow" :style="{left: leftOffset }"></div>
      <slot />
      <a class="e-tooltip__close-button" @click.stop="switchPopup">Close</a>
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'InfoIcon',
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  data() {
    return {
      classes: {
        'e-icon': true,
        'e-icon__info': true,
        'e-icon__cursor': true,
        'e-icon__active': false,
      },
      isPopupOpen: false,
      topOffset: 0,
      leftOffset: 0,
    };
  },
  computed: {
    ...mapState(['isMobile']),
  },
  methods: {
    switchPopup() {
      this.isPopupOpen = !this.isPopupOpen;

      if (this.isMobile) {
        if (this.isPopupOpen) {
          const overlay = document.createElement('div');
          overlay.classList.add('overlay');
          document.querySelector('body').append(overlay);
          document.querySelector('body').classList.add('has-overlay');
        } else {
          document.querySelector('body').querySelector('.overlay').remove();
          document.querySelector('body').classList.remove('has-overlay');
        }
      }
    },
    getClassesForIcon() {
      const classes = {
        ...this.classes,
        'e-icon--active': this.isPopupOpen,
      };

      classes[`e-icon--${this.size}`] = true;

      return classes;
    },
    setTopOffset() {
      if (this.isMobile) {
        this.topOffset = 'auto';
      } else {
        this.topOffset = `${(this.size === 'large' ? 40 : 25)}px`;
      }
    },
    setLeftOffset() {
      if (this.isMobile) {
        const offset = (this.$el.getBoundingClientRect().left - this.$el.querySelector('.e-tooltip__text').getBoundingClientRect().left);
        this.leftOffset = `${offset + (this.size === 'large' ? 2 : -3)}px`;
      }
    },
    closePopup() {
      if (this.isPopupOpen) {
        this.switchPopup();
      }
    },
  },
  mounted() {
    this.setTopOffset();
  },
  updated() {
    this.setTopOffset();
    this.setLeftOffset();
  },
};
</script>

<style lang="scss">
</style>
